import React, { useState, useEffect } from "react";
import ProfileHeader from "./ProfileHeader";
import ProfileForm from "./ProfileForm";
import { useGlobal } from "../../contexts/GlobalContext";

export default function EditProfileLayout() {
  const { user } = useGlobal(); // Get the logged-in user
  const [profileData, setProfileData] = useState(null);

  // Load user data once user is available
  useEffect(() => {
    if (user) {
      setProfileData({
        firstName: user.FirstName || "",
        middleName: user.MiddleName || "",
        lastName: user.LastName || "",
        suffix: user.Suffix || "",
        gender: user.Gender || "",
        birthDate: user.DateOfBirth || "",
        civilStatus: user.CivilStatus || "",
        address: [
          user.Address,
          user.City,
          user.Province,
          user.PostalCode,
          user.Country,
        ]
          .filter(Boolean)
          .join(", "),
        email: user.Email || "",
        position: user.Position || "",
        mobile: user.ContactNumber || "",
        github: "",
        philHealth: "12-34567891-2",
        sss: "09-8765432-1",
        pagIbig: "4321-8765-0987",
        profileImage: user.ProfileImage || null,
      });
    }
  }, [user]);

  if (!profileData) return <p>Loading...</p>;

  const handleSave = (updatedData) => {
    console.log("Updated Profile:", updatedData);
    // call your API to save updated profile
  };

  return (
    <div className="edit-profile-container">
      <ProfileHeader profile={profileData} setProfile={setProfileData} />
      <ProfileForm initialData={profileData} onSubmit={handleSave} />
    </div>
  );
}
